/**
 * @name store/modules/places/index.js
 * @module app
 *
 * @description
 * The typescript store modules.
 *
 * @project spotgig4app
 * @author Hyuga on 2019/06/03
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */
import PhoneNumberAuthorization from '../../../api/phone_number_authorization'
import * as types from './mutation-types'

const state = {
  loading: false,
}

const getters = {
  loading: state => state.loading,
}

const actions = {
  CodeRegist({ commit }, params) {
    return new Promise((resolve, reject) => {
      PhoneNumberAuthorization.regist(params, response => {
        if ( Object.keys(response.data.errors).length === 0 ) {
          resolve(response)
        } else {
          reject(response.data.errors)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  CodeCertification({ commit }, params) {
    commit(types.LOADING, true);

    return new Promise((resolve, reject) => {
      PhoneNumberAuthorization.certification(params, response => {
        if ( Object.keys(response.data.errors).length === 0 ) {
          resolve(response)
        } else {
          reject(response.data.errors)
        }
      }).catch(reject)
        .finally(() => commit(types.LOADING, false));
    })
  },
}

const mutations = {
  [types.LOADING] (state, payload) {
    state.loading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
